import { Flex, Tag } from 'antd';
import { useCallback } from 'react';

import type { ClientStatusEnum } from '@app/components/RecordModal/components/RecordDetails/types';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import {
  RECORD_STATUSES,
  PF,
} from '@pages/Clients/NewClientsList/data/constants';
import type { RecordsStatusItem } from '@pages/Clients/NewClientsList/types';

export const RecordsStatusSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeRecordsStatuses } = useNewClientsListContext();

  const { recordsStatuses } = filtersMap.get(id)!;

  const onClose = useCallback(
    (value: ClientStatusEnum) => {
      const newStatuses = recordsStatuses.filter((status) => status !== value);
      onChangeRecordsStatuses(newStatuses, id);
    },
    [recordsStatuses, onChangeRecordsStatuses, id]
  );

  if (recordsStatuses.length === 0) {
    return null;
  }

  const selectedStatuses: RecordsStatusItem[] = RECORD_STATUSES.filter(
    (status) => recordsStatuses.includes(status.value)
  );

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      {selectedStatuses.map(({ value, label }) => (
        <Tag
          key={value}
          className={`${PF}__tag`}
          closable
          onClose={() => onClose(value)}
        >
          {label}
        </Tag>
      ))}
    </Flex>
  );
};
